import { defineComponent as t, computed as u, toDisplayString as r } from "vue";
const f = /* @__PURE__ */ t({
  __name: "RenderString",
  props: {
    value: {}
  },
  setup(e) {
    const n = u(() => e.value === "" ? "''" : e.value === null ? "null" : e.value === void 0 ? "undefined" : e.value);
    return (a, l) => r(n.value);
  }
});
export {
  f as default
};
